// extracted by css-extract-rspack-plugin
export default {"checkboxLabelRoot":"B3HtL"};